module.exports = __webpack_public_path__ + "img/melissajaneshair.2f405466.png";